import S from "./index.module.scss";
import SShared from "../shared.module.scss";

const TERMS_MOCK = [
  {
    title: "Змішувачі",
    description:
      "(за винятком картриджів, кран-букс, гумових ущільнювачів, перемикачів, шлангів, душових / гігієнічних лійок)",
    term: "10 років",
  },
  {
    title: "Мебельнi раковини",
    description: "",
    term: "25 років",
  },
  {
    title: "Керамічні картриджі змішувачів",
    description: "(гарантія на непротікання)",
    term: "5 років",
  },
  {
    title: "Зливні механізми для керамічних бачків та бачків прихованого монтажу",
    description: "",
    term: "10 років",
  },
  {
    title: "Інші складові частини змішувачів",
    description:
      "(гумові ущільнювачі, перемикачі, шланги, кран-букси, донні клапани, душовi / гiгiєнiчнi лiйки і т.д.)",
    term: "2 роки",
  },
  {
    title: "Зливні бачки для прихованого монтажу, монтажні елементи",
    description: "",
    term: "10 років",
  },
  {
    title: "Душові гарнітури",
    description: "",
    term: "2 роки",
  },
  {
    title: "Гумові ущильнювачi",
    description: "",
    term: "1 рік",
  },
  {
    title: "Акрилові ванни",
    description: "",
    term: "15 років",
  },
  {
    title: "Клавіши для зливних бачків прихованого монтажу",
    description: "",
    term: "2 роки",
  },
  {
    title: "Устаткування гідромасажних ванн",
    description: "",
    term: "3 роки",
  },
  {
    title: "Сидіння з кришкою",
    description: "",
    term: "2 роки",
  },
  {
    title: "Душові кабіни, куточки, огорожі, гідромасажні панелі",
    description: "",
    term: "3 роки",
  },
  {
    title: "Електронна кришка-бiде",
    description: "",
    term: "2 роки",
  },
  {
    title: "Гідрозатвори, системи зливу/переливу ванн",
    description: "",
    term: "1 рік",
  },
  {
    title: "Меблі для ванних кімнат",
    description: "",
    term: "3 роки",
  },
  {
    title: "Caнфарфор",
    description: "",
    term: "25 років",
  },
  {
    title: "Аксесуари для ванної кімнати",
    description: "(латунь)",
    term: "10 років",
  },
  {
    title: "Аксесуари для ванної кімнати",
    description: "(хромований метал)",
    term: "5 років",
  },
];

const ServiceTerms = () => {
  return (
    <div className={SShared.mainWrapper}>
      <div className={SShared.topContent}>
        <h2 className={SShared.slogan}>Термиiни гарантiї на продукцiю</h2>
        <h3 className={SShared.subtitle}>
          Гарантійні терміни на вироби, придбані для приватного використання починають діяти з моменту продажу.
        </h3>
      </div>
      <div className={S.termsWrapper}>
        {TERMS_MOCK.map(({ title, description, term }, idx) => (
          <div className={S.item} key={idx}>
            <div className={S.textWrapper}>
              <p className={S.itemTitle}>{title}</p>
              {description && <p className={S.itemDesc}>{description}</p>}
            </div>
            <p className={S.itemTerm}>{term}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceTerms;
